import { render, staticRenderFns } from "./BatchEditForm.vue?vue&type=template&id=1622d774"
import script from "./BatchEditForm.vue?vue&type=script&lang=js"
export * from "./BatchEditForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports